module.exports = __webpack_public_path__ + "static/media/reducer-options.cbad9de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reducer-options.png
// module id = 67
// module chunks = 0